"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllowanceAmountInput = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const react_hook_form_1 = require("react-hook-form");
const types_1 = require("@framework/types");
const mui_inputs_mask_1 = require("@dzambalaorg/mui-inputs-mask");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const AllowanceAmountInput = () => {
    const { decimals, contractType } = (0, react_hook_form_1.useWatch)();
    if (contractType !== types_1.TokenType.ERC20) {
        return ((0, jsx_runtime_1.jsx)(ui_kit_1.Alert, { severity: "warning", sx: { mt: 2 }, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "alert.allowanceWarning" }) }));
    }
    return (0, jsx_runtime_1.jsx)(mui_inputs_mask_1.EthInput, { name: "amount", units: decimals, symbol: "", required: true });
};
exports.AllowanceAmountInput = AllowanceAmountInput;
//# sourceMappingURL=index.js.map